import api from '../api';

// Адрес логотипа компании (корпоративный тариф). Путь приходит от backend как «api-static/logos/...».
export function companyLogoUrl(path) {
    if (!path) return null;
    if (/^https?:\/\//.test(path)) return path;
    const base = (api.defaults.baseURL || '').replace(/\/api$/, '');
    return `${base}/${path.replace(/^\//, '')}`;
}
